import { HttpEventType, type HttpEvent, type HttpHandlerFn, type HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap, type Observable } from 'rxjs';
import { EtagService } from '../services/etag.service';

export const responseInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    const etagService = inject(EtagService);

    return next(req).pipe(
        tap(event => {
            if (event.type === HttpEventType.Response) {
                etagService.registerEtag(event.headers.get('etag'), event.headers.get('last-modified'));
            }
        }),
    );
};
